import * as React from 'react'
import styled from 'styled-components'
import { TeaserCard } from '../../components/UI/TeaserCard'
import { ThemeName } from '../../lib/constants'
import { typoParagraphS } from '../../lib/styles/Typography'
import { renderRichtextChecklist } from '../../lib/utils/renderRichtextChecklist'
import { TeaserCardBlok } from '../../types'
import { useI18n } from '../../lib/context/i18n'

export interface TeaserCardItemProps {
  children?: React.ReactNode
  justify?: 'left' | 'center'
  direction?: 'row' | 'column'
  step?: string
  width?: string
  assetHeight?: string
  assetWidth?: string
  blok: TeaserCardBlok
  href?: string
  buttonLabel?: string
  theme?: ThemeName
}

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;

  .prose p,
  .prose li {
    ${typoParagraphS}
  }

  .prose ul li:not(:last-child) {
    margin-bottom: 0.2rem;
  }
`

const Footer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.9rem;
`

export const TeaserCardItem = ({ blok, direction = 'column', children, justify = 'left', width, step, assetHeight, assetWidth, href, theme }: TeaserCardItemProps) => {

  const { getTranslatedUrlFromLink } = useI18n()

  return (
    <TeaserCard
      assetHeight={blok.assetHeight || assetHeight}
      assetWidth={blok.assetWidth || assetWidth}
      noBorder={blok.noBorder}
      isSourceForge={blok.isSourceForge}
      href={blok.link && (blok.link.url || blok.link.cached_url) ? getTranslatedUrlFromLink(blok.link) : href}
      title={blok.title}
      subtitle={blok.subtitle}
      products={blok.products}
      asset={blok.image}
      step={step}
      justify={justify}
      alignment={blok.alignment}
      direction={direction}
      buttons={blok.buttons}
      themeBackground={blok.themeBackground}
      themeSubtitle={blok.themeSubtitle}
      subtitleFontSize={blok.subtitleFontSize}
      titleFontSize={blok.titleFontSize}
      contentFontSize={blok.contentFontSize}

    >
      <ContentWrapper>
        <div className="prose">{renderRichtextChecklist(blok.description)}</div>
        {!!children && <Footer>{children}</Footer>}
      </ContentWrapper>
    </TeaserCard>
  )
}
